export const environment = {
    production: true,
    loyaltyProgramEnabled: false,
    apiUrl: "https://app.moneymax.mk/api/v1",
    dashboard: "https://app.moneymax.mk/login",
    loanCalculatorUrl: "https://app.moneymax.mk/loan-calculator",
    referralUrl: "https://app.moneymax.mk/settings/referral",
    sentryDsn: "https://9d57d04542a92d65c3668789c7b95517@o4507978700619776.ingest.de.sentry.io/4510107817148496"
};
